module.exports = __webpack_public_path__ + "img/4.30d0ffbf.png";